import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

function OutlinedCard({ data, description }) {
  return (
    <Card variant="outlined">
      <React.Fragment>
        <CardContent>
          <Typography sx={{ fontSize: 30 }} color="red" gutterBottom>
            {data}
          </Typography>
          <Typography variant="body2">{description}</Typography>
        </CardContent>
      </React.Fragment>
    </Card>
  );
}

export default function SnapshotDataCards() {
  return (
    <>
      <Box>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        >
          <Grid item xs={12} sm={4} md={4}>
            <OutlinedCard
              data="Ksh 410 bln"
              description="Real Estate Outstanding Loans"
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <OutlinedCard
              data="0.5%"
              description="Credit Growth Rate 2021"
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <OutlinedCard
              data="26,723"
              description="Mortgage Accounts (2021)"
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <OutlinedCard
              data="13.1%"
              description="Non-Performing Loans Dec 2021"
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <OutlinedCard
              data="14%"
              description="Non-Performing Loans Mar 2022"
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <OutlinedCard
              data="14.1%"
              description="Non-Performing Loans Apr 2022"
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <OutlinedCard
              data="11.3%"
              description="Avg. Mortgage Lending Rate 2021"
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <OutlinedCard
              data="88%"
              description="Adjustable Rate Mortgages in 2021"
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
